import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
        modal_container: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            margin: 0,
            padding: 0,
            "@media print": {
                zoom: '80%',
                width: '100%',
                height: "100%"
            }
        },
        view_invoice_container: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            alignItems: 'center',
        },
        invoice_container: {
            display: 'flex',
            flexDirection: 'column',
            width: '800px',
            marginTop: '16px',
            height: 'calc(100vh - 185px)',
            overflow: 'auto',
            overflowX: 'hidden',
            backgroundColor: theme.palette.common.white,
            borderRadius: '4px',
            padding: '16px',
            border: `1px solid ${theme.palette.grey[200]}`,
            "@media print": {
                width: '880px',
                marginLeft: '260px',
                boxShadow: 'none',
                padding: '0',
                border: `none`,
                height: "100%",
                overflow: 'hidden',
                overflowX: 'hidden',
                margin: '0cm'
            }
        },
        toolbar_container: {
            display: "flex",
            width: '100%',
            boxSizing: 'border-box',
            justifyContent: 'flex-end',
            backgroundColor: theme.palette.common.white,
            padding: '16px',
            "@media print": {
                display: 'none'
            },
            "& > *:not(:last-child)": {
                marginRight: '16px'
            }
        },
        invoice_data_container: {
            border: `1px solid ${theme.palette.grey[900]}`,
            display: 'flex',
            padding: '8px 0',
            flexDirection: 'column',
            borderRadius: '8px',
            position: 'relative',
        },
        column: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            // maxWidth: '50%',
            "& svg": {
                maxWidth: '300px',
                maxHeight: '100px'
            }
        },
        column_container: {
            display: 'grid',
            gridTemplateColumns: '250px auto 150px',
            "@media print": {
                gridTemplateColumns: '280px 400px 150px',
            }
        },
        row: {
            display: 'flex',
            flexDirection: 'row',
        },
        last_column: {
            alignItems: 'flex-end'
        },
        agency_name: {
            color: theme.palette.primary.dark,
            fontSize: '24px',
            textTransform: 'uppercase'
        },
        body: {
            display: 'flex',
            flexDirection: 'column',
            padding: '0 8px'
        },
        title: {
            fontSize: "20px",
            textAlign: 'center',
            textTransform: 'uppercase'
        },
        subtitle: {
            fontSize: "15px",
            fontWeight: 800
        },
        table: {
            width: '100%',
            borderCollapse: 'collapse',
            border: `1px solid ${theme.palette.grey[400]}`,
            borderRadius: '4px',
            marginTop: '10px',
            "& td": {
                border: `1px solid ${theme.palette.grey[400]}`,
                padding: '0 4px'
            }
        },
        table_header: {
            backgroundColor: theme.palette.grey[200],
            textAlign: 'center',
            fontWeight: 800
        },
        table_footer: {
            backgroundColor: theme.palette.grey[200],
            fontWeight: 800,
            "& td:first-child": {
                textAlign: 'end'
            }
        },
        sign_container: {
            width: '100%',
            height: '1px',
            borderTop: `2px solid ${theme.palette.grey[800]}`,
            marginTop: '20px'
        },
        payment_row: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            "& > *:first-child": {
                marginRight: '4px',
            }
        },
        payments_container: {},
        qr_container: {
            border: `1px solid #ccc`,
            width: 'fit-content',
            flexGrow: 0,
            height: 'fit-content',
            padding: '8px',
            borderRadius: '4px'
        },
        fee: {
            fontSize: '13px',
            color: theme.palette.grey[400],
            marginLeft: '4px'
        },
        order_item_container: {
            marginTop: '10px',
            borderTop: '2px solid #4a4a4a',
            paddingTop: '10px'
        },
        margin_top_4: {
            marginTop: '4px'
        },
        margin_top_8: {
            marginTop: '8px'
        },
        width_90: {
            width: '90%'
        },
        articles_container: {
            marginTop: '10px'
        },
        articles_name: {
            fontSize: '16px',
            fontWeight: 800
        }
    }))
;

export {useStyles}